import * as forms from "@client/forms";
import * as typography from "@client/shared/typography";
import {ManagerLayout} from "@client/site/ManagerLayout";
import {Switch} from "@headlessui/react";
import {classNames, server} from "@reactivated";
import React from "react";

import {TargetForm} from "./CreateTarget";

export const Template = (props: server.manager.templates.UpdateTarget) => {
    const title = "Update target";
    const targetForm = forms.useForm(props.form);
    const [useMealPlan, setUseMealPlan] = React.useState(
        targetForm.values.meal_plan != "" && targetForm.values.meal_plan != null,
    );

    const nextMealPlan = props.meal_plans.find(
        (m) => m.id.toString() == targetForm.values.meal_plan,
    );

    const fillMacrosFromMealPlan = () => {
        if (nextMealPlan != null) {
            targetForm.update({
                ...targetForm.values,
                // name: nextMealPlan.name,
                calories_target:
                    nextMealPlan.calories != null
                        ? parseInt(nextMealPlan.calories).toString()
                        : "",
                protein_target:
                    nextMealPlan.protein != null
                        ? parseInt(nextMealPlan.protein).toString()
                        : "",
                fat_target:
                    nextMealPlan.fat != null
                        ? parseInt(nextMealPlan.fat).toString()
                        : "",
                carbs_target:
                    nextMealPlan.carbs != null
                        ? parseInt(nextMealPlan.carbs).toString()
                        : "",
            });
        }
    };

    return (
        <ManagerLayout title={title} currentClientManagerId={props.client_manager.id}>
            <form id="delete" method="POST" action="">
                <forms.CSRFToken />
                <forms.FormErrors form={targetForm} />
            </form>
            <form
                className="mx-auto w-full max-w-xl bg-white px-10 py-6 shadow-xs ring-1 ring-gray-900/5 sm:rounded-xl"
                noValidate
                method="POST"
                action=""
                onSubmit={(event) => {
                    event.preventDefault();

                    if (!useMealPlan && targetForm.values.name.trim() === "") {
                        targetForm.setServerErrors(
                            {
                                name: ["A target name is required"],
                            },
                            {revision: targetForm.revision},
                        );
                    } else if (
                        useMealPlan == true &&
                        (targetForm.values.meal_plan == "" ||
                            targetForm.values.meal_plan == null)
                    ) {
                        targetForm.setServerErrors(
                            {
                                meal_plan: ["A meal plan is required"],
                            },
                            {revision: targetForm.revision},
                        );
                    } else if (forms.ready(targetForm)) {
                        event.currentTarget.submit();
                    }
                }}
            >
                <div className="hidden">
                    <forms.Fields form={targetForm} fields={["type"]} />
                </div>

                <forms.CSRFToken />
                <div className={classNames("my-4 flex flex-col gap-4")}>
                    <h2 className="text-base/6 font-medium text-gray-900">
                        Update target
                    </h2>
                    <Switch.Group
                        as="div"
                        className="flex items-center justify-between"
                    >
                        <span className="flex grow flex-col">
                            <Switch.Label
                                as="span"
                                className="text-sm/6 font-medium text-gray-900"
                                passive
                            >
                                Use a meal plan
                            </Switch.Label>
                            <Switch.Description
                                as="span"
                                className="text-sm text-gray-500"
                            >
                                Meal plans let you prescribe specific foods or
                                guidelines.
                            </Switch.Description>
                        </span>
                        <Switch
                            checked={useMealPlan}
                            onChange={setUseMealPlan}
                            className={classNames(
                                useMealPlan ? "bg-indigo-600" : "bg-gray-200",
                                "relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-hidden focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2",
                            )}
                        >
                            <span
                                aria-hidden="true"
                                className={classNames(
                                    useMealPlan ? "translate-x-5" : "translate-x-0",
                                    "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out",
                                )}
                            />
                        </Switch>
                    </Switch.Group>
                    {useMealPlan ? (
                        <div className="flex flex-col gap-2 sm:flex-row">
                            <div className="flex-1">
                                <forms.Fields
                                    form={targetForm}
                                    fields={["meal_plan"]}
                                />
                            </div>
                            <div
                                className={classNames(
                                    "mb-1",
                                    (targetForm.values.type == "LOG" ||
                                        targetForm.values.meal_plan == "" ||
                                        targetForm.values.meal_plan == null) &&
                                        "invisible",
                                    targetForm.errors.meal_plan != null
                                        ? "mt-2 sm:self-center"
                                        : "sm:self-end",
                                )}
                            >
                                <button
                                    type="button"
                                    onClick={fillMacrosFromMealPlan}
                                    className={classNames(
                                        "rounded-sm bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 hover:bg-gray-50",
                                    )}
                                >
                                    Use meal plan macros
                                </button>
                            </div>
                        </div>
                    ) : (
                        <forms.Fields form={targetForm} fields={["name"]} />
                    )}
                    <div className={classNames("flex flex-col gap-2 max-w-lg")}>
                        <TargetForm form={targetForm} type={targetForm.values.type} />
                    </div>
                </div>
                <typography.ButtonGroup>
                    <typography.Button submit>Update</typography.Button>
                    <typography.Button submit name="delete" form="delete">
                        Delete
                    </typography.Button>
                </typography.ButtonGroup>
            </form>
        </ManagerLayout>
    );
};
